import React, { JSX } from "react";
import { TextareaField } from "@hatch-digital-nl/abs-storybook/legacy";
import { setFormValues } from "../RejectCertificateModalSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useAssociatedFieldId } from "../../../common/utils/useAssociatedFieldId";

export const TextareaFieldComponent = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const { formValues } = useAppSelector(
        (state) => state.rejectCertificateModal,
    );
    const [error, setError] = React.useState<string | null>(null);
    const { fieldId, fieldRef } = useAssociatedFieldId();

    return (
        <div className={"c-reject-certificate-modal__form-group"}>
            <div className={"c-reject-certificate-modal__form-group__label"}>
                <label htmlFor={fieldId}>Reden van afkeuren</label>
            </div>
            <div ref={fieldRef}>
                <TextareaField
                    required={true}
                    name={"comment"}
                    onChange={(value) =>
                        dispatch(setFormValues({ comment: value }))
                    }
                    value={formValues?.comment || ""}
                    onInvalid={(event) => {
                        event.preventDefault();
                        setError("Dit veld is verplicht.");
                    }}
                />
            </div>
            {error && <p className={"c-error-message"}>{error}</p>}
        </div>
    );
};
